import { appUrl } from 'utils/wrappers';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('canada_post_registrations'),
  rootKey: 'canada_post_registration',
});



// WEBPACK FOOTER //
// ./app/models/canada_post_registration.js